/* eslint-disable array-bracket-spacing */
import React from 'react';
import _, { divide, map } from 'lodash'
import { uuid } from './../../util'
import { use, app, api } from 'xadmin'
import { _t } from 'xadmin-i18n'
import { Card, Input, Tooltip, Radio, DatePicker, Checkbox, Space, Popconfirm, message, Button, Select, Menu, InputNumber, Form, FormTitle } from 'antd'
import { App, C, Check, Icon } from 'xadmin-ui'
import { Model, } from 'xadmin-model'
import NoData from '../../components/NoData'
import DptListPage from './components/DptListPage'
import { HasPermission } from 'xadmin-auth'
import PasswordField from './components/PasswordField'
import { formatDepartment } from './../../components/util'
import PermissionField from './components/PermissionField'
import NodeModalSelect from '../../components/NodeModalSelect'
import { DepartmentSelectField } from '../../components/DepartmentSelect'
import { DepartmentTressSidebar } from '../../components/DepartmentTree'
import UidComponent from './../../components/UidComponent'
import moment from 'moment'
import { DeleteOutlined, EditOutlined, EyeInvisibleOutlined, EyeTwoTone, CheckCircleOutlined, CloseCircleOutlined } from '@ant-design/icons';
import UserView from './components/UserView'
import { UserOverTime } from './../setting/RenderSetting'
import { SchemaForm } from 'xadmin-form';
import sha1 from 'crypto-js/sha1'
// import sm from 'sm-crypto/dist/sm2'

const Department = {
  name: 'department',
  resource: 'core/department',
  type: 'object',
  title: '部门',
  icon: <Icon svg={require('../../icon/Department.svg')} />,
  forceGetItem: true,
  properties: {
    name: {
      type: 'string',
      title: '部门名称',
      description: '部门名称不可以重复'
    },
    uid: {
      type: 'string',
      title: '部门编号',
      description: '部门编号不可以重复'
    },
    // id: {
    //   type: 'string',
    //   title: '部门编号'
    // },
    fullName: {
      type: 'string',
      title: '部门全称'
    },
    parent: {
      type: 'object',
      title: '所属部门',
      description: '定义父级部门',
      properties: {}
    },
    users: {
      type: 'array',
      title: '用户列表',
      notInclude: true,
      description: '部门包含用户的定义',
      items: {
        type: 'object',
        name: 'User',
        relateTo: 'User',
        properties: {
          id: { type: 'string' },
          name: { type: 'string' }
        }
      }
    },
    node: {
      type: 'array',
      title: '资产管理',
      notInclude: true,
      description: '部门管理资产的选择',
      items: {
        type: 'object',
        name: 'Node',
        relateTo: 'Node',
        resource: 'node',
        properties: {
          id: { type: 'string' },
          name: { type: 'string' }
        }
      }
    },
    order: {
      type: 'number',
      title: '部门顺序',
      showInList: false,
      description: '根据填写的数值大小排序',
    },
    remark: {
      title: '备注',
      type: 'string',
      width: 350,
    }
  },
  is_extend: true,
  partialSave: true,
  permission: { view: true, add: true, edit: true, delete: true },
  form: [
    'name',
    {
      key: 'uid',
      validate: value => {
        return /\s/.test(value) ? "编号不能存在空格" : null;
        // return (/^[\u2E80-\u9FFF\w\-\_\!\@\$\(\)\:]{1,}$/ig.test(value) ? null : '编号必须为汉字、字母、数字、特殊字符!@$-_():')
      },
      component: props => <UidComponent type={'department'} {...props} />
    },
    { key: 'parent', component: DepartmentSelectField },
    'users',
    { key: 'node', component: NodeModalSelect }, 'order', 'remark'
  ],
  defaultPageSize: 10000,
  searchFields: ['name'],
  editableFields: ['remark'],
  editableFieldsGetItems: true,
  listFields: ['name', 'parent'],
  projectFields: ['parent', 'order'],
  display: d => `${d.name}(${d.uid})`,
  display_field: 'fullName',
  convertItem: d => ({ ...d, fullName: `${d.name}(${d.id || d.uid})`, uid: d.uid || d.id }),
  required: ['name', 'uid'],
  dataTableProps: (columns, items) => {
    const { modelState: { wheres } } = use('model')
    return {
      scroll: { y: 700 },
      dataSource: JSON.stringify(wheres) != '{}' ? items : formatDepartment(items),
      childrenColumnName: 'child'
    }
  },
  itemActions: [
    ({ item }) => (<DptEditBtn item={item} />),
    ({ item }) => (<DptDeleteBtn item={item} />),
  ],
  components: {
    Pagination: () => null,
    ListPage: DptListPage,
    DataEmpty: props => <Card><NoData /></Card>,
  }
}

const DptEditBtn = ({ item }) => {
  if (item?.id == 'defaultFixDept' || item?.uid == 'defaultFixDept') {
    return null
  }
  return (
    <HasPermission permission="department.edit">
      <Button size="small" onClick={() => { app.go(`/app/model/department/${encodeURIComponent(item.id)}/edit`) }}>
        <EditOutlined />
      </Button>
    </HasPermission>
  )
}

const DptDeleteBtn = ({ item }) => {
  const { deleteItem } = use('model.delete', item)
  if (item?.id == 'defaultFixDept' || item?.uid == 'defaultFixDept') {
    return null
  }
  return (
    <HasPermission permission="department.delete">
      <Popconfirm
        title="确定删除该该部门吗？"
        onConfirm={() => { deleteItem() }}
        okText="确定"
        cancelText="取消">
        <Button size="small" type="danger">
          <DeleteOutlined />
        </Button>
      </Popconfirm>

    </HasPermission>
  )
}

const NameInput = ({ input }) => {

  return (<>
    <Input type="text" name="name" style={{ display: 'none' }} />
    <Input name="name" type="text" autocomplete="off" value={input.value} onChange={(e) => input.onChange(e.target.value)} />
  </>)
}

const PasswordInput = ({ input }) => {
  return (<>

    <Input name="password" type="password" style={{ display: 'none' }} />
    <Input.Password name="password" type="password" autocomplete="new-password" {...input} value={input.value}
      onChange={(e) => input.onChange(e.target.value)} onBlur={input.onBlur}
    />
  </>)
}

const UseTime = ({ input }) => {
  let [usetime, setUseTime] = React.useState(input.value)
  let [maxLimit, setLimit] = React.useState()

  React.useEffect(() => {
    (async () => {
      let href = location.href.slice(location.href.lastIndexOf('/') + 1)
      if (href == 'edit') {
        if (input.value || _.isNumber(input.value)) {
          setUseTime(input.value / 86400);
          input.onChange(input.value / 86400)
        } else {
          setUseTime(null);
          input.onChange(null)
        }
      }
      let remainingTime = await api({ name: 'core/license' }).fetch('', {}).then(({ json }) => json.remainingTime)
      setLimit(remainingTime)
    })()
  }, [])

  const limitNumber = value => {
    let newValue = Number((value + '').replace(/[^0-9]/g, ''))
    newValue = newValue > maxLimit ? maxLimit : newValue
    setUseTime(newValue)
    input.onChange(newValue)
  }

  return (
    <Space direction="horizontal"><InputNumber min={0} max={maxLimit} value={usetime} onChange={limitNumber} />（天）</Space>
  )
}

const StartTime = props => {
  const { input: { value, onChange } } = props

  React.useEffect(() => {
    if (!value) onChange({ type: 'createTime' })
  }, [])

  const handleChange = e => {
    let checked = e.target.value
    checked == 'createTime' ? onChange({ type: checked }) : onChange({ type: checked, time: moment(new Date()).format('YYYY-MM-DD HH:mm:ss') })
  }

  const dateChange = (date, dateString) => {
    dateString ? onChange({ ...value, time: dateString }) : onChange({ ...value, time: null })
  }

  return (
    <>
      <Radio.Group style={{ marginTop: '0.3rem' }} onChange={handleChange} value={value.type}>
        <Radio value={'createTime'}>以创建时间开始</Radio>
        <Radio value={'custom'}>自定义起始时间</Radio>
      </Radio.Group>
      <div style={{ marginTop: '1rem' }}>
        {
          value && value.type == 'custom' ?
            <Space direction="vertical">
              <DatePicker disabledDate={(current) => current <= moment(new Date())} allowClear onChange={dateChange} value={value.time ? moment(value.time) : null} showTime />
            </Space> : null
        }
      </div>
    </>
  )
}

const WarningfilterSelect = props => {
  const { input: { value, onChange } } = props
  const { settings } = use('settings')
  let warningFilter = settings?.warning?.warningFilter

  const handleChange = value => {
    let newValue = value?.length ? value.map(item => ({ id: item.value, name: item.label })) : []
    onChange(newValue)
  }

  return (
    <Select
      mode="multiple" allowClear labelInValue
      onChange={handleChange} value={value?.length ? value.map(item => ({ label: item.name, value: item.id })) : []}
    >
      {
        warningFilter?.length ? warningFilter.map(item => {
          return <Select.Option key={item.id}>{item.name}</Select.Option>
        }) : null
      }
    </Select>
  )
}

const saveUsers = (value, needExamine) => {
  const addUserreject = value?.examineType === 'add' && value?.examineStatus === 'nopass';
  const changeUserreject = value?.examineType === 'edit' && value?.examineStatus === 'nopass';
  // const changeuser = !value?.examineType && !value?.examineStatus

  return new Promise((resolve, reject) => {
    return api({ name: `core/user/${value.id}` }).fetch('', {
      method: 'PATCH',
      body: JSON.stringify({
        ...value, pwdExpireConfig: {
          hasPwdExpire: value?.pwdExpireConfigSetting?.hasPwdExpire,
          pwdExpire: value?.pwdExpireConfigSetting?.pwdExpire?.time,
        }, examineStatus: addUserreject || changeUserreject ? 'examine' : value?.examineStatus,
        expireUse: _.isNumber(value.expireUse) || value.expireUse ? (value.expireUse) * 86400 : null
      })
    }).then((res) => {
      message.success(!needExamine ? '修改用户成功 ！' : (addUserreject ? "提交审核成功,请等待审核结果 ！" : "提交审核成功，审核通过后，修改内容将会生效"))
    }).catch((err) => {
      // message.error(err?.json?.[Object.keys(err?.json)?.[0]] || '保存用户失败',err?.detail)
      reject(err)
    })
  })

}

const isPermission = (user, view) => {
  return user.permissions.indexOf(view)
}

const deleteUserItem = (newSchema, userForm, field) => {
  delete newSchema.properties[field]
  userForm.forEach((val, index) => {
    if (val == field) userForm.splice(index, 1)
    if (val?.key == field) userForm.splice(index, 1)
  })
  return newSchema
}

const UserModel = props => {
  const { saveItem } = use('model.save', { successMessage: '操作成功 ！' })
  const { user } = use('redux', state => ({ user: state.user }))
  const userSchema = app.get('models').User
  let newSchema = _.cloneDeep(userSchema)
  const [publicKey, setPublicKey] = React.useState()

  const { settings } = use('settings')
  const { userExpand } = settings || {}

  let userForm = [
    { key: 'name', component: NameInput }, 'email',
    { key: 'phone', validate: (value) => value && !(/^1(3|4|5|6|7|8|9)\d{9}$/.test(value)) ? '请输入正确的电话号码' : null },
    // 'roles', 'department', 
    {
      key: 'roles',
      validate: value => value?.length > 0 ? null : '角色不能为空',
    },
    {
      key: 'department',
      validate: value => value?.length > 0 ? null : '部门不能为空',
    },
    { key: 'node', component: NodeModalSelect },
    {
      key: 'password', attrs: { type: 'password' },
      validate: (value, values) => {
        const nousername = settings.userExpand?.nousername
        const username = values?.name
        if (nousername && value?.includes(username)) {
          return '密码不能包含用户名';
        }
        return (/^(?![^a-zA-Z]+$)(?!\D+$)/ig.test(value) ? null : '密码必须为字母与数字组合')
      },
      component: PasswordInput
    },
    {
      key: 'password2', attrs: { type: 'password' },
      validate: (value, { password }) => value == password ? ((/^(?![^a-zA-Z]+$)(?!\D+$)/ig.test(value) ? null : '密码必须为字母与数字组合')) : '两次输入密码不一致',
    },
    'remark',
    { key: 'expireUse', component: UseTime },
    { key: 'startTime', component: StartTime }, 'pwdExpireConfigSetting',
    { key: 'warningFilter', component: WarningfilterSelect },
    'onlyNode', 'noChildDept', { key: 'status', label: '休眠', component: UserStatus }, 'binddingtalk', 'bindwechatee', ...(userExpand?.form || [])
  ]
  let required = ['name', 'phone', 'email', 'password', 'password2']

  if (!user?.isSuper) {
    if (user.permissions?.length) {
      let nodePermission = isPermission(user, 'node.view')
      let departPermission = isPermission(user, 'department.view')
      let rolePermission = isPermission(user, 'role.view')
      if (userSchema && departPermission == -1) deleteUserItem(newSchema, userForm, 'department')
      if (userSchema && nodePermission == -1) deleteUserItem(newSchema, userForm, 'node')
      if (userSchema && rolePermission == -1) deleteUserItem(newSchema, userForm, 'roles')
      newSchema.form = userForm
      newSchema.required = required
      userForm.forEach(val => {
        if (val == 'department' || val?.key == 'department') { required = [...required, 'department'] }
        if (val == 'roles' || val?.key == 'roles') { required = [...required, 'roles'] }
      })
    }
  } else {
    newSchema.required = [...required, 'department', 'roles']
  }

  const schema = use('auth.userExpand', { newSchema })
  const needExamine = settings?.userExpand?.needExamine
  React.useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await api({ name: '/core//crypto/getPublicKey' }).fetch('', {
          method: 'GET'
        });
        const publicKey = response.json.content;
        setPublicKey(publicKey);
      } catch (error) {
        console.error(error);
      }
    };

    fetchData();
  }, []);

  return (
    <Model schema={schema} modelKey="user" // name="User"
      props={{
        form: userForm
      }}
    >
      <C is="Model.DataForm"
        {...props}
        onSubmit={(item) => {
          saveItem({
            ...item,
            password: sha1(item.password).toString(),
            password2: sha1(item.password2).toString(),
            pwdExpireConfig: {
              hasPwdExpire: item?.pwdExpireConfigSetting?.hasPwdExpire,
              pwdExpire: item?.pwdExpireConfigSetting?.pwdExpire?.time,
            },
            expireUse: _.isNumber(item.expireUse) || item.expireUse ? (item.expireUse) * 86400 : null
          }).then((res) => {
            message.success(needExamine ? '提交审核成功，请耐心等待审核结果' : '添加用户成功！')
            app.go('/app/model/User/list')
          }).catch((err) => {
            message.error(err?.[Object.keys(err)?.[0]] || '创建用户失败', err?.detail)
          })
        }}

      />
    </Model>
  )
}


const UserModelEdit = props => {
  const { user } = use('redux', state => ({ user: state.user }))
  const userSchema = app.get('models').User
  let newSchema = _.cloneDeep(userSchema)
  let userForm = newSchema.form
  if (!user?.isSuper) {
    if (user.permissions?.length) {
      let nodePermission = isPermission(user, 'node.view')
      let departPermission = isPermission(user, 'department.view')
      let rolePermission = isPermission(user, 'role.view')
      if (userSchema && departPermission == -1) deleteUserItem(newSchema, userForm, 'department')
      if (userSchema && nodePermission == -1) deleteUserItem(newSchema, userForm, 'node')
      if (userSchema && rolePermission == -1) deleteUserItem(newSchema, userForm, 'roles')
      newSchema.form = userForm
      userForm.forEach(val => {
        if (val == 'department' || val?.key == 'department') { newSchema.required = [...newSchema.required, 'department'] }
        if (val == 'roles' || val?.key == 'roles') { newSchema.required = [...newSchema.required, 'roles'] }
      })
    }
  } else {
    newSchema.required = [...newSchema.required, 'department', 'roles']
  }

  const schema = use('auth.userExpand', { newSchema })
  return <Model schema={schema} modelKey="user">
    <C is="Model.TabsForm" {...props} />
  </Model>
}

const BatchDeleteOpenid = props => {
  const { modelDispatch } = use('model')
  const { selected } = use('model.select')
  const disabled = selected && !_.isEmpty(selected)

  const onClick = () => {
    if (disabled) {
      Promise.all(selected.map(item => {
        return api({ name: `core/user/${item?.id}` }).fetch('', { method: 'PATCH', body: JSON.stringify({ openid: '' }) })
          .then(({ json }) => json)
      })).then((result) => {
        message.success('批量解绑成功!')
        modelDispatch({ type: 'SELECT_CLEAR' })
        modelDispatch({ type: 'GET_ITEMS' })
      })
    }
  }
  return <Menu.Item {...props} key={'action_delete_openid'} onClick={onClick} disabled={!disabled}>批量解绑openid</Menu.Item>
}

const BatchDelete = props => {
  const { modelDispatch } = use('model')
  const { selected } = use('model.select')
  const disabled = selected && !_.isEmpty(selected)
  const { settings } = use('settings')
  const needExamine = settings?.userExpand?.needExamine

  const onClick = () => {
    if (disabled) {
      Promise.all(selected.map(item => {
        return api({ name: `core/user/${item?.id}` }).fetch('', { method: 'DELETE' })
          .then(({ json }) => json)
      })).then((result) => {
        message.success(needExamine ? '提交审核成功，请耐心等待审核结果!' : '删除成功！')
        modelDispatch({ type: 'SELECT_CLEAR' })
        modelDispatch({ type: 'GET_ITEMS' })
      })
    }
  }
  return <Menu.Item {...props} key={'action_delete_id'} onClick={onClick} disabled={!disabled}>批量删除</Menu.Item>
}
const RolesList = props => {
  const { input } = props
  const [roleData, setRoleData] = React.useState({ loading: false, data: [] })
  React.useEffect(() => {
    setRoleData({ loading: true })
    let query = { "limit": 1000, "project": { "id": 1, "name": 1, 'disabled': 1 }, filter: { disabled: { '$ne': true } }, "withCount": true }
    const querystr = encodeURIComponent(JSON.stringify(query))
    api({ name: 'core/role' }).fetch('?query=' + querystr, {}).then(({ json }) => {
      setRoleData({ loading: false, data: json })
    })
  }, [])

  const handleChange = (value) => {
    let newValue = value?.length ? value.map(item => ({ id: item?.value, name: item?.label })) : []
    input.onChange(newValue)
  }

  return <Select placeholder="请选择角色" labelInValue loading={roleData.loading} mode="multiple" allowClear onChange={handleChange}
    value={input?.value?.length ? input.value.map(item => ({ value: item?.id, label: item?.name })) : undefined}
  >
    {
      roleData.data?.length ? roleData.data.map(item => {
        return <Select.Option value={item?.id}>{item?.name}</Select.Option>
      }) : null
    }
  </Select>
}

const UserStatus = props => {
  const { input: { value, onChange } } = props
  const [nochange, setOnchange] = React.useState(false)
  const { form } = use('form')
  const disable = form.getState().values?.disabled
  const status = form.getState().values?.status
  const [checked, setChecked] = React.useState(value ? value != 'active' : disable)
  const timeoutTimeUse = form.getState().values?.timeoutTimeUse
  const deadTime = moment(timeoutTimeUse).format('YYYY-MM-DD HH:mm:ss')
  const now = moment().format('YYYY-MM-DD HH:mm:ss')

  let isBefore = moment(deadTime).isBefore(now)

  const Bool = app.get('form_fields')['checkbox'].component
  const onBoolChange = v => {
    const checked = v.target.checked
    if (isBefore && status == 'sleep') {
      setOnchange(true)
    } else {
      onChange(checked ? 'sleep' : 'active')
      setChecked(checked)
    }
  }
  return <C is='Form.ColGroup' field={{}} meta={{}}>
    <Bool {...props} input={{ checked: checked, value: checked, onChange: onBoolChange, disabled: nochange }} group={(props) => props.children} />
  </C>
}

UserStatus.useGroup = false
const ActiveUsers = ({ item }) => {
  const { settings } = use('settings')
  const { saveItem } = use('model.save', { successMessage: '注销成功！' })
  const needLogout = settings?.userExpand?.needLogout
  const needExamine = settings?.userExpand?.needExamine
  const { deleteItem } = use('model.delete', item)
  const [checkedDelete, setCheckedDelete] = React.useState(true)
  const examineType = item?.examineType
  const examineStatus = item?.examineStatus
  const id = item.id
  const cancel = (e) => {
    // message.error('取消');
  };

  const onChange = (e) => {
    const check = e.target.checked
    setCheckedDelete(check)
  };
  const onDelete = () => {
    api({ name: 'core/user' }).fetch(`/${id}`, {
      method: 'DELETE'
    }).then((res) => {
      message.success('提交审核成功，请耐心等待审核结果！')
    }
    )
  }
  const Delete = () => {
    needLogout ? (
      checkedDelete ? onDelete() : saveItem({ status: 'close', id: item.id }))
      : (
        needExamine ? onDelete() : deleteItem()
      )
  }

  const title = (
    needLogout ? (
      checkedDelete ? (
        <>
          <div>该用户将彻底删除，请谨慎操作!</div>
          <Checkbox onChange={onChange} defaultChecked='true'>彻底删除</Checkbox>
        </>) : (
        <>
          <div> 该用户将被注销，注销后无法恢复激活状态，请谨慎操作!!</div>
          <Checkbox onChange={onChange} defaultChecked='true'>彻底删除</Checkbox>
        </>)
    ) : (
      <>
        <a href="#">确认删除</a>
      </>
    )
  )
  return <div>
    <Button onClick={() => app.go(`/app/model/User/${item.id}/edit`)} ><EditOutlined /></Button>
    {examineType == 'delete' && examineStatus == 'examine' ? (
      <Tooltip
        title='该用户删除正在审核中'
      >
        <Button disabled><DeleteOutlined /></Button>
      </Tooltip>
    ) : (
      <Popconfirm
        title={title}
        onConfirm={Delete}
        onCancel={cancel}
        okText="确认"
        cancelText="取消"
      >
        <Button style={{ background: 'red', color: '#fff' }}><DeleteOutlined /></Button>
      </Popconfirm >
    )
    }
  </div >
}
const User = {
  name: 'user',
  resource: 'core/user',
  type: 'object',
  icon: 'user',
  title: '用户',
  properties: {
    name: {
      type: 'string',
      title: '用户名',
      description: '用户名不可以重复'
    },
    email: {
      type: 'string',
      title: '邮箱',
      // format: 'email'
    },
    phone: {
      type: 'string',
      title: '电话'
    },
    password: {
      title: '密码',
      type: 'string',
      maxLength: 30,
      minLength: 6,
      // showInGrid: false,
      showInList: false,
      fieldType: 'password',
      description: '用户登录密码需是6-30位数字与字母的组合'
    },
    password2: {
      title: '重复密码',
      type: 'string',
      maxLength: 30,
      minLength: 6,
      description: '6-30位数字与字母的组合',
      fieldType: 'password',
      // showInList: false,
      showInList: false,

    },
    roles: {
      type: 'array',
      title: '用户角色',
      notInclude: true,
      description: '用户角色决定了用户的权限，用户可以属于多个角色',
      items: {
        type: 'object',
        name: 'Role',
        relateTo: 'Role',
        properties: {
          id: { type: 'string' },
          name: { type: 'string' }
        }
      },
      field: {
        component: RolesList
      }
    },
    department: {
      type: 'array',
      title: '用户所属部门',
      fieldType: 'department',
      description: '用户所属部门可以多选，用户可查看所属部门下的资产信息',
      items: {
        type: 'object',
        name: 'Department',
        relateTo: 'Department',
        properties: {
          id: { type: 'string' },
          name: { type: 'string' }
        }
      }
    },
    node: {
      type: 'array',
      title: '资产管理',
      notInclude: true,
      description: '用户管理资产的选择',
      items: {
        type: 'object',
        name: 'Node',
        relateTo: 'Node',
        resource: 'node',
        properties: {
          id: { type: 'string' },
          name: { type: 'string' }
        }
      }
    },
    onlyNode: {
      title: '仅管理个人资产',
      type: 'boolean',
      description: '勾选后，该用户将无法管理所属部门下的资产'
    },
    noChildDept: {
      title: '不查看子部门报警数据',
      type: 'boolean',
      description: '勾选后将无法查看用户所属部门的子部门及其子部门的报警数据'
    },
    binddingtalk: {
      title: '绑定钉钉',
      type: 'boolean',
      description: '绑定钉钉后，用户可以接收到平台推送的钉钉消息'
    },
    examineType: {
      title: '审核类型',
      type: 'string',
      enum: ['add', 'edit', 'delete'],
      enum_title: ['新增用户', '修改用户', '删除用户'],
      showInList: false,
      exame: true
    },
    examineStatus: {
      title: '审核状态',
      type: 'string',
      enum: ['examine', 'pass', 'nopass', "endCancel"],
      enum_title: ['审核中', '审核通过', '未通过', '结束'],
      showInList: false,
      exame: true
    },
    status: {
      title: '用户状态',
      type: "string",
      enum: ['active', 'sleep', 'close'],
      enum_title: ['激活', '休眠', '注销'],
      showInList: false,
      isstatus: true
    },
    remark: {
      title: '备注',
      type: 'string'
    },
    startTime: {
      type: 'object',
      title: '起始时间',
      properties: {
        type: {
          title: '类型',
          type: 'string'
        },
        time: {
          type: 'string',
          title: '起始时间',
        }
      }
    },
    expireUse: {
      title: '有效时长',
      type: 'number',
      description: '最大时长为项目的有效时长，且不可输入小数'
    },
    warningFilter: {
      title: '报警分组',
      type: 'array',
      items: {
        type: 'object',
        properties: {
          id: { type: 'string', title: 'id' },
          name: { type: 'string', title: '名称' }
        }
      }
    },
    pwdExpireConfigSetting: {
      title: '强制修改密码',
      type: 'object',
      properties: {
        hasPwdExpire: {
          title: '开启',
          type: 'boolean'
        },
        pwdExpire: {
          title: '时长',
          type: 'object',
          properties: {}
        }
      },
      form: ['*', { key: 'pwdExpire', component: UserOverTime }],
      description: '启用时，定义修改密码的时长'
    },
    openid: {
      title: 'openid',
      type: 'string'
    },
    // openname: {
    //   title: '微信名',
    //   type: 'string'
    // },
    createTime: {
      title: '创建时间',
      type: 'string',
      format: 'date-time'
    },
    // custom: {
    //   title: '扩展字段',
    //   type: 'object',
    //   field: {
    //     component: Custom
    //   }
    // }
    bindwechatee: {
      title: '绑定企业微信',
      type: 'boolean',
      description: '绑定企业微信后，用户可以在企业微信中接收到平台推送的消息'
    }
  },
  editableFields: ['openid', 'remark'],
  orders: { createTime: 'DESC' },
  partialSave: true,
  forceGetItem: true,
  permission: { view: true, add: true, edit: true, delete: true },
  dataTableProps: (columns) => {
    return {
      scroll: { x: 1000, },
      yScroll: true,
      columns: columns.map(c => c.key == '__action__' ? { ...c, width: 80 } : { ...c, width: c.width || 100 })
    }
  },
  form: [
    // 'name',
    { key: 'name', component: NameInput },
    'email', 'phone', //'roles', 'department',
    {
      key: 'roles',
      validate: value => value?.length > 0 ? null : '角色不能为空',
    },
    {
      key: 'department',
      validate: value => value?.length > 0 ? null : '部门不能为空',
    },
    { key: 'node', component: NodeModalSelect },
    {
      key: 'password', component: PasswordField
    },
    'remark',
    { key: 'expireUse', component: UseTime },
    { key: 'startTime', component: StartTime },
    { key: 'warningFilter', component: WarningfilterSelect }, 'pwdExpireConfigSetting',
    'onlyNode', 'noChildDept',
    { key: 'status', label: '休眠', component: UserStatus }, 'binddingtalk', 'bindwechatee'
  ],
  itemActions: [
    (props) => {
      const { settings } = use('settings')
      const status = props?.item?.status
      const id = props?.item?.id
      const needExamine = settings?.userExpand?.needExamine
      const { deleteItem } = use('model.delete', props)
      const onDelete = () => {
        needExamine ?
          api({ name: 'core/user' }).fetch(`/${id}`, {
            method: 'DELETE'
          }).then((res) => {
            message.success('提交审核成功，请耐心等待审核结果！')
          }
          ) : deleteItem()
      }

      return (status !== 'close' ? <ActiveUsers {...props} /> : <Button onClick={onDelete} style={{ backgroundColor: 'red', color: "#fff" }}><DeleteOutlined /></Button>)
    },
  ],

  formEffect: form => {
    form.useField('expireUse', state => {
      let value = state.value
      if (value) {
        form.setFieldData('startTime', { display: true })
      } else {
        form.setFieldData('startTime', { display: false })
      }
    })
    const { id, isSuper } = form.getState().values || {}
    form.setFieldData('status', { display: id == 'admin' || isSuper == true ? false : true })
  },
  blocks: {
    'model.list.sidemenu': ({ model }) => <DepartmentTressSidebar />
  },
  // initialValues: {
  //   wheres: { filter: { isSuper: { "$ne": true }, isShare: { "$ne": true } } }
  // },
  batchActions: [item => <BatchDelete {...item} />, item => <BatchDeleteOpenid {...item} />],
  components: {
    DataForm: props => {
      const { saveItem } = use('model.save', props)
      const { settings } = use('settings')
      const needExamine = settings?.userExpand?.needExamine;

      return props.id ? <UserModelEdit {...props} saveItem={(value) => saveUsers(value, needExamine)} /> : <UserModel saveItem={saveItem} />
    },
    DataEmpty: props => <Card><NoData /></Card>,
    ListPage: props => <UserView {...props} />
  },
  searchFields: ['name', 'email', 'status'],
  required: ['name', 'email', 'phone'],
  listFields: ['name', 'email', 'status'],
  projectFields: ['name', 'email', 'status', 'timeoutTimeUse', 'disabled', 'examineStatus', 'examineType'],
  filters: {
    submenu: ['name', 'email', 'phone', 'remark', 'status'],
  },
  is_extend: true,
  relations: {
    department: {}
  },
  fieldRender: {
    name: ({ item, wrap: WrapComponent }) => {
      const status = item.status
      return status == 'sleep' ? <WrapComponent>
        <Tooltip title={`用户【${item.name}】已处于休眠状态，无法登录!`}>
          <span>{item.name}</span>
        </Tooltip>
      </WrapComponent> : <span>{item.name}</span>
    },
    expireUse: ({ item, wrap: WrapComponent }) => {
      return (
        <WrapComponent>
          <span>{item.expireUse ? `${item.expireUse / 86400}天` : '空'}</span>
        </WrapComponent>
      )
    },
    startTime: ({ item, wrap: WrapComponent }) => {
      let startTime = item.startTime && item.startTime.type == 'custom' ? item.startTime.time :
        item.startTime && item.startTime.type == 'createTime' ? moment(item.createTime).format('YYYY-MM-DD HH:mm:ss') : '空'
      return (
        <WrapComponent>
          <span>{startTime}</span>
        </WrapComponent>
      )
    },
    openid: ({ item, wrap: WrapComponent }) => {
      return (
        <WrapComponent>
          <span>{item.openid ? item.openid : '空'}</span>
        </WrapComponent>
      )
    },
    createTime: ({ item, wrap: WrapComponent }) => {
      return (
        <WrapComponent>
          <span>{item.createTime ? moment(item.createTime).format('YYYY-MM-DD HH:mm:ss') : '空'}</span>
        </WrapComponent>
      )
    },
    custom: ({ item, wrap: WrapComponent }) => {
      return (
        <WrapComponent>
          <span>{item.custom ? JSON.stringify(item.custom) : null}</span>
        </WrapComponent>
      )
    },
    status: ({ item, wrap: WrapComponent }) => {
      const obj = {
        'active': '激活',
        'sleep': '休眠',
        'close': '注销'
      }
      const disabled = (_.isNil(item?.disabled) && _.isNil(item?.examineStatus)) ? 'active' : (_.isNil(item?.disabled) ? '' : item?.disabled ? 'sleep' : 'active')
      const timeoutTimeUse = item?.timeoutTimeUse
      const deadTime = moment(timeoutTimeUse).format('YYYY-MM-DD HH:mm:ss')
      const now = moment().format('YYYY-MM-DD HH:mm:ss')
      let isBefore = moment(deadTime).isBefore(now)
      const value = item?.status ? item?.status : disabled
      return (
        isBefore ? (
          (<WrapComponent>
            <span>{item?.status == 'sleep' ? (<>
              <Tooltip title={'该用户登录有效时长已过期，无法取消休眠!'}>
                <span>休眠</span>
              </Tooltip>
            </>) : obj[value]}</span>
          </WrapComponent>)
        ) : (<WrapComponent>
          <span>{obj[value]}</span>
        </WrapComponent>)
      )
    }
  },
  formProps: {
    group: props => <C is="CustomTable.FieldGroup" {...props}></C>,
    component: props => <C is="CustomTable.FormLayout" {...props}></C>
  }
}

const BatchDeleteRoles = props => {
  const { modelDispatch, atoms } = use('model')
  const { selected } = use('model.select')
  const disabled = selected && !_.isEmpty(selected)

  const onClick = () => {
    if (disabled) {
      Promise.all(selected.map(item => {
        return api({ name: `core/role/${item?.id}` }).fetch('', { method: 'DELETE' })
          .then(({ json }) => json)
      })).then((result) => {
        message.success(_t1('批量删除成功'))
        modelDispatch({ type: 'SELECT_CLEAR' })
        modelDispatch({ type: 'GET_ITEMS' })
      }).catch(err => {
        modelDispatch({ type: 'SELECT_CLEAR' })
        modelDispatch({ type: 'GET_ITEMS' })
      })
    }
  }
  return <Menu.Item {...props} onClick={onClick} disabled={!disabled}>批量删除</Menu.Item>
}

const Role = {
  name: 'role',
  resource: 'core/role',
  type: 'object',
  icon: <Icon svg={require('../../icon/Role.svg')} />,
  title: '角色',
  // rolePermission: [
  //   { key: 'role.view', title: '查看' },
  // ],
  properties: {
    name: {
      title: '名称',
      type: 'string',
      description: '角色名称不可以重复'
    },
    description: {
      title: '描述',
      type: 'string',
      description: '定义角色详细描述'
    },
    users: {
      type: 'array',
      title: '用户列表',
      notInclude: true,
      description: '定义具有该角色的用户',
      items: {
        type: 'object',
        name: 'User',
        relateTo: 'User',
        properties: {
          Id: { type: 'string' },
          name: { type: 'string' }
        }
      }
    },
    disabled: {
      type: 'boolean',
      title: '禁用',
      description: '禁用后该角色的所有用户不可以登录平台'
    },
    permission: {
      type: 'array',
      title: '角色权限',
      items: {},
      showInList: false,
    },
    isBlackList: {
      title: '黑名单',
      type: 'boolean'
    }
  },
  components: {
    DataEmpty: props => <Card><NoData /></Card>
  },
  itemActions: [
    'edit', 'delete',
    ({ item }) => {
      const { getItems } = use('model.getItems')
      const { user } = use('auth.user')
      const id = item.id
      const onCopy = () => {
        api({ name: 'core/role' }).fetch(`/${id}`, {
          method: 'GET'
        }).then((res) => {
          const permission = res.json?.permission
          const users = res.json?.users
          const disabled = res.json?.disabled
          api({ name: 'core/role' }).fetch('', {
            method: 'POST',
            body: JSON.stringify(_.omit({ ...res?.json, permission: permission, users: users, disabled: disabled, name: item.name + `${'副本'}${uuid(4, 16)}` }, 'id'))
          }).then(() => {
            message.success('复制成功')
            getItems()
          })
        })
      }
      return (
        user?.isSuper ? <Button onClick={onCopy} >复制</Button> : null
      )
    }
  ],
  orders: { createTime: 'DESC' },
  permission: { view: true, add: true, edit: true, delete: true },
  form: ['name', 'description', 'users', { key: 'permission', component: PermissionField }, 'disabled', 'isBlackList'],
  searchFields: ['name'],
  forceGetItem: true,
  is_extend: true,
  required: ['name', 'description'],
  listFields: ['name', 'description', 'disabled'],
  batchActions: [item => <BatchDeleteRoles {...item} />, 'export']
}

const SafeZone = {
  name: 'safezone',
  resource: 'core/safezone',
  type: 'object',
  icon: <Icon svg={require('../../icon/safezone.svg')} />,
  title: '安全区',
  properties: {
    num: {
      type: 'number',
      title: '序号',
      width: 150
    },
    name: {
      type: 'string',
      title: '安全区',
      field: {
        validate: v => !(v && v.trim()) ? '安全区不能为空' : null,
      }
    }
  },
  components: {
    DataEmpty: props => <Card><NoData /></Card>
  },
  itemActions: [],
  orders: { num: 'ASC' }, // DESC,ASC
  permission: { view: true, add: false, edit: false, delete: false },
  rolePermission: [
    { key: 'safezone.view', title: '查看' },
    { key: 'safezone.edit', title: '修改' }
  ],
  forceGetItem: true,
  is_extend: true,
  form: ['num', 'name'],
  required: ['name'],
  listFields: ['num', 'name'],
  editableFields: ['name'],
  batchActions: null
}

export default {
  Department,
  Role,
  User,
  SafeZone
}

export { isPermission, deleteUserItem }